module.exports = __webpack_public_path__ + "static/media/C3-Resume.20c76c28.svg";